<template>
    <div style='touch-action: manipulation' class="mb-5">
        <div>
            <v-toolbar class="main">
                <button class="nav-back" @click="goBack">&lt; Logga ut</button>
            </v-toolbar>
            <div class="">
                <v-stepper v-model="e1">
                    <v-stepper-header>
                        <v-divider></v-divider>
                        <v-stepper-step step="1" :complete="e1 > 1"><span @click="e1 = 1">Interna</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2" :complete="e1 > 2"><span @click="e1 = 2">Externa</span></v-stepper-step>
                        <v-divider></v-divider>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <h1>Leveranser</h1>
                            <div style="padding-bottom: 20px">
                                <v-text-field placeholder="Sök Leverans" v-model="filter"></v-text-field>
                            </div>
                            <v-layout row wrap align-center=true>
                                <v-flex xs4>
                                    <v-switch
                                        color="primary"
                                        label="Inkommande"
                                        v-model="showEjKlara"
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs4>
                                    <v-switch
                                        color="primary"
                                        label="Färdiga"
                                        v-model="showKlara"
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs4>
                                    <v-btn block color="primary" class="mb-2 text-left" @click="$store.commit('getTours')">Ladda om</v-btn>
                                </v-flex>
                            </v-layout>
                            <center v-if="this.$store.state.fetchPending" style="padding-top: 50px">
                                <v-progress-circular v-if="this.$store.state.fetchPending" indeterminate :size="70" :width="7" color="green"></v-progress-circular>
                            </center>
                            <div v-if="!this.$store.state.fetchPending" style="padding-top: 20px">
                                <v-expansion-panel popout v-for="(delivery, i) in getDeliveries" :key="i">
                                    <v-expansion-panel-content v-if="klaraCheck(delivery.status)">
                                        <div slot="header"><strong>{{ delivery.staff_name }}</strong> <br />
                                            <br>
                                            {{ delivery.delivery_day }}
                                            <span style="float:right">{{ delivery.localisedStatus }}</span>
                                            <br>
                                        </div>
                                        <v-card>
                                            <v-card-text>
                                                <v-btn v-if="delivery.status == 'running'" block color="primary" class="mb-2 text-left" @click="moveToDeliveryDetails(delivery)">Check in</v-btn>
                                                <v-btn v-if="delivery.status == 'finished'" block color="primary" class="mb-2 text-left" @click="moveToDeliveryReview(delivery)">Review</v-btn>
                                            </v-card-text>
                                        </v-card>
                                        <v-spacer></v-spacer>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </div>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <h1>Distributors</h1>
                            <div>
                                <v-text-field placeholder="Search for Distributor" v-model="filter"></v-text-field>
                            </div>
                            <br>
                            <center style="padding-top: 50px">
                                <v-progress-circular v-if="this.$store.state.fetchPending" indeterminate :size="70" :width="7" color="green"></v-progress-circular>
                            </center>
                            <vue-virtual-list v-if="!this.$store.state.fetchPending" :row-height="45" :dynamic-height="false">
                                <v-expansion-panel popout v-for="(distributor, i) in getDistributors" :key="i">
                                    <v-expansion-panel-content>
                                        <div slot="header">
                                            <strong>{{ distributor.name }}</strong>
                                        </div>
                                        <v-card>
                                            <v-card-text>
                                                <v-btn block color="primary" class="mb-2 text-left" @click="moveToDistributorDelivery(distributor)">Checka</v-btn>
                                            </v-card-text>
                                        </v-card>
                                        <v-spacer></v-spacer>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </vue-virtual-list>

                            <ul style="list-style: none;">
                                <li v-if="getDistributors.length === 0 && !this.$store.state.fetchPending" :xs="24" :sm="24" :md="24">
                                    <center><h4>Ingen matchning hittad</h4></center>
                                </li>
                            </ul>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </div>
</template>

<script>
    import vl from 'vue-virtual-list'

    export default {
        components: {
            vueVirtualList: vl,
        },
        name: 'Warehouse_Home',
        data(){
            return{
                completedDeliveries: this.setCompletedDeliveries() || [],
                distributors: this.$store.state.distributors,
                filter: '',
                showKlara: false,
                showEjKlara: true,
                e1: 0,
                items: [
                  {
                    id: 1,
                    name: 'Internal'
                  },
                  {
                    id: 2,
                    name: 'External'
                  }
                ]
            }
        },
        methods: {
            klaraCheck(status){
                if (status == "running" && this.showEjKlara) {
                    return true;
                } else if(status == "finished" && this.showKlara) {
                    return true;
                } else {
                    return false;
                }
            },
            setCompletedDeliveries(){
                if(this.completedDeliveries && this.completedDeliveries.length==0){
                    this.completedDeliveries = this.$store.state.completedDeliveries;
                }
            },
          moveToDeliveryDetails(transaction){
              this.$store.state.isReview = false;
              this.$store.state.currentDelivery = transaction;
              this.$router.push('Delivery_Details');
          },
          moveToDeliveryReview(delivery){
              this.$store.state.isReview = true;
              this.$store.state.currentDelivery = delivery;
              this.$router.push('Review');
          },
          moveToDistributorDelivery(distributor){
              this.$store.state.currentDistributor = distributor;
              this.$store.state.currentSignatories = distributor.signatories;
              this.$store.state.isDistributor = true;
              this.$router.push('Distributor_Delivery');
          },
          goBack(){
              if (this.$store.state.activeProfile.role == 'hybrid-warehouse') {
                  this.$store.state.activeProfile.role = 'hybrid';
              }

              this.$store.commit('unsetActiveProfile');

              this.$router.push('/');
          }
        },
        computed: {
            getDeliveries: function getDeliveries() {
                var _this = this;

                var deliveries = this.$store.state.deliveries.filter(function (player) {
                    return player.staff_name.toLowerCase().indexOf(_this.filter.toLowerCase()) !== -1;
                });

                return deliveries;
            },
            getDistributors: function getDistributors() {
                var _this = this;

                var distributors = this.$store.state.distributors.filter(function (player) {
                    return player.name.toLowerCase().indexOf(_this.filter.toLowerCase()) !== -1;
                });

                return distributors;
            }
        },
        created: function(){

            this.$store.state.isDistributor = false;

            this.$store.commit("getTours");
            this.$store.commit('getDistributors');

            if(this.$store.state.auth.token == null || this.$store.state.auth.token == ""){
                this.$router.push('/');
            }

        }
    }
</script>

<style>
    [v-cloak] {
        display: none;
    }

    .stepper:not(.stepper--vertical) .stepper__label{
        display:inherit!important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Warehouse_Home.vue